import { ReactNode } from 'react';
import { ResponsiveDialog } from './ResponsiveDialog';

/** Keep one modal/focus trap while navigating from the menu into its screens. */
export function MenuPresentation({
  open,
  onClose,
  titleId,
  children,
}: {
  open: boolean;
  onClose: () => void;
  titleId?: string;
  children: ReactNode;
}) {
  return (
    <ResponsiveDialog open={open} onClose={onClose} aria-labelledby={titleId}>
      {children}
    </ResponsiveDialog>
  );
}
